<template>
  <section v-if="sliderLoad && slides" class="bought__section">
    <div class="container">
      <h2 class="cart__subtitle h2-title">Новинки</h2>
      <div class="bought__wrapper flex">
        <li class="swiper mySwiper bought__swiper flex" style="overflow: hidden">
          <ul class="list-reset swiper-wrapper flex bought">
            <swiper :modules="modules" :pagination="true" :slides-per-view="2" :space-between="10">
              <template v-for="slide in slides">
                <swiper-slide>
                  <li class="swiper-slide card flex">
                    <ProductItem :item="slide"></ProductItem>
                  </li>
                </swiper-slide>
              </template>
            </swiper>
          </ul>
        </li>
      </div>

    </div>
  </section>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper';
import ProductItem from './ProductItem'

export default {
  props: [

  ],
  data: () => ({
    modules: [Pagination],
    sliderLoad: false,
    slides: false
  }),
  computed: {

  },
  async created() {
    this.slides = await this.slider();
    this.sliderLoad = true;
  },
  methods: {
    async slider() {
    //  if (this.$store.getters.homeNew === false || this.$store.getters.homeNew == undefined)
        await this.$store.dispatch('fetchHomeNew')
      return this.$store.getters.homeNew;
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    ProductItem
  }
}
</script>